export const tabsConfig = [
  {
    name: "单据",
    id: "certificate"
  },
  {
    name: "审批流",
    id: "approval-flow"
  }
];

export const getCheckSheetDetails = (
  contractOnAccountAmounts,
  formMetadata
) => {
  let details = [];

  contractOnAccountAmounts.forEach(item => {
    const config = formMetadata.columnMetadatas.find(
      el => el.id === item.columnId
    );

    let { columnName, columnCode, columnValueType } = config;
    let { value } = item;

    details.push({ columnName, columnCode, value, columnValueType});
  });

  return details;
};

// search conditions
export const conditions = [
  {
    type: "department",
    span: 8
  },
  {
    type: "fields",
    span: 8,
    label: "搜索查询",
    key: "titleOrEmployeeName"
  },
  {
    type: "flowStatus",
    span: 8
  },
  {
    type: "time",
    span: 8
  }
];

export const applyForm = {
  overtimeApply: [
    {
      applyDescription: "加时原由",
      duration: "加时时长",
      applyEmployee: "加时人员",
      startTime: "开始时间",
      endTime: "结束时间"
    }
  ],

  generalApply: [
    {
      applyDescription: "申请事由"
    }
  ],

  replenishApply: [
    {
      replenishTime: "补卡时间",
      applyDescription: "缺卡原由"
    }
  ],

  leaveApply: [
    {
      applyDescription: "请假原由",
      duration: "请假时长",
      vacationName: "请假类型",
      startTime: "开始时间",
      endTime: "结束时间"
    }
  ],

  filingApply: [
    {
      applyDescription: "备案原由",
      applyEmployee: "备案人员",
      filingDuration: "备案时长",
      startTime: "开始时间",
      endTime: "结束时间"
    }
  ],

  loanApply: [
    {
      applyDescription: "借款原由",
      projectName: "项目名称",
      loanAmount: "借款金额",
      repaymentDate: "还款日期",
      bankAccountNumber: "收款账户"
    }
  ],

  businessTripApply: [
    {
      applyDescription: "出差事由",
      applyEmployee: "出差人员"
    }
  ],

  travelReimburseApply: [
    {
      projectName: {
        lg: 6,
        sm: 12,
        label: "关联项目"
      },
      businessTripApplyName: {
        lg: 10,
        sm: 12,
        label: "关联申请"
      },
      applyEmployee: {
        lg: 8,
        sm: 12,
        label: "出差人员"
      }
    },
    {
      applyDescription: {
        label: "报销事由",
        lg: 24,
        sm: 24
      }
    }
  ],

  commonReimburseApply: [
    {
      projectName: "关联项目",
      createEmployeeName: "报销人",
      departmentName: "报销部门",
      customerSupplierName: {
        lg: 6,
        sm: 12,
        label: "客商关系"
      },
      applyDescription: {
        label: "报销事由",
        lg: 24,
        sm: 24
      }
    }
  ]
};

export const basicColumns = [
  { title: "单据名称", key: "applyTitle", align: "center", minWidth: 150 },
  { title: "单据编号", key: "applyCode", align: "center", minWidth: 150 },
  {
    title: "制单人",
    key: "createEmployeeName",
    align: "center",
    minWidth: 100
  },
  {
    title: "部门",
    key: "departmentName",
    align: "center",
    minWidth: 100
  }
];

export const applyColumns = {
  overtimeApply: [],
  generalApply: [],
  replenishApply: [],
  leaveApply: [],
  filingApply: [],
  loanApply: [],
  businessTripApply: [],

  travelReimburseApply: [
    // {
    //   title: "项目",
    //   key: "projectName",
    //   align: "center",
    //   minWidth: 100
    // },
    // {
    //   title: "报销金额",
    //   key: "projectName",
    //   align: "center",
    //   minWidth: 100
    // },
    // {
    //   title: "状态",
    //   key: "projectName",
    //   align: "center",
    //   minWidth: 100
    // },
  ],
  loanReimburseApply: [],
  commonReimburseApply: []
};

// 单据状态
export const flowStatusConfig = {
  approvalIng: {
    itemName: "审批中",
    status: "#2c8cf0",
    icon: "el-icon-loading"
  },
  passApproval: {
    itemName: "审批通过",
    status: "#18be6a",
    icon: "el-icon-circle-check"
  },
  rejectApproval: {
    itemName: "审批驳回",
    status: "#ec4115",
    icon: "el-icon-circle-close"
  },
  withdrawnApproval: {
    itemName: "已撤回",
    status: "#e6ebf1",
    icon: "el-icon-refresh-right"
  },
  revokeIngApproval: {
    itemName: "撤销中",
    status: "#2c8cf0",
    icon: "el-icon-loading"
  },
  revokeRejectApproval: {
    itemName: "撤销驳回（审批通过）",
    status: "#ec4115",
    icon: "el-icon-warning-outline"
  },
  revokedApproval: {
    itemName: "已撤销",
    status: "#fec171",
    icon: "el-icon-document-delete"
  },
  waitPay: {
    itemName: "待支付",
    status: "#fec171",
    icon: "el-icon-document-delete"
  },
  reconciled: {
    itemName: "支付中",
    status: "#fec171",
    icon: "el-icon-document-delete"
  },
  finished: {
    itemName: "已付讫",
    status: "#fec171",
    icon: "el-icon-document-delete"
  },
  paymentFail: {
    itemName: "支付失败",
    status: "#fec171",
    icon: "el-icon-document-delete"
  }
};

export const getFlowStatus = flowStatusCode => {
  if (!flowStatusConfig[flowStatusCode]) {
    return "#18be6a";
  }
  return flowStatusConfig[flowStatusCode].status;
};

export const getFlowIcon = flowStatusCode => {
  if (!flowStatusConfig[flowStatusCode]) {
    return "el-icon-refresh-right";
  }
  return flowStatusConfig[flowStatusCode].icon;
};

// 审批流状态
export const flowConfig = [
  {
    title: "提交申请",
    icon: "el-icon-document-checked",
    status: "finished_initiator",
    color: "#18be6a"
  },
  {
    title: "等待审批",
    icon: "el-icon-time",
    status: "wait_approver",
    color: "#a6a6a6"
  },
  {
    title: "审批中",
    icon: "el-icon-more",
    status: "ongoing_approver",
    color: "#fec171"
  },
  {
    title: "审批通过",
    icon: "el-icon-success",
    status: "finished_approver",
    color: "#18be6a"
  },
  {
    title: "自动抄送",
    icon: "el-icon-s-promotion",
    status: "wait_copy",
    color: "#a6a6a6"
  },
  {
    title: "自动抄送",
    icon: "el-icon-s-promotion",
    status: "finished_copy",
    color: "#18be6a"
  },
  {
    title: "等待支付",
    icon: "el-icon-time",
    status: "wait_cashier",
    color: "#a6a6a6"
  },
  {
    title: "支付中",
    icon: "el-icon-loading",
    status: "ongoing_cashier",
    color: "#fe9900"
  },
  {
    title: "支付完成",
    icon: "el-icon-circle-check",
    status: "finished_cashier",
    color: "#fe9900"
  },
  {
    title: "评论",
    icon: "el-icon-warning-outline",
    status: "comment",
    color: "#8a4af3"
  },
  {
    title: "已撤回",
    icon: "el-icon-refresh-left",
    status: "withdraw",
    color: "#ff5722"
  }
];

export const basicCostDetailFields = [
  "startTime",
  "endTime",
  "costAmount",
  "taxAmount",
  "remark",
  "notes",
  "id",
  "isEdited",
  "editedCostDetail",
  "isModifying",
  "taxAmountUnsaved",
  "warningMessageCode"
];

export const invoiceWarningStatus = [
  {
    code: "pass",
    message: "已通过验证，但与团队开票信息不一致，请检查确认。",
    codeList: ["invoiceInfoDifferent"]
  },
  {
    code: "repetition",
    message: "此项费用可能使用了重复报销的发票，请留意风险！",
    codeList: ["approvalIng"]
  },
  {
    code: "finishPaymentByRepetition",
    message: "本单有重复报销发票，且其他单据已经支付，请谨慎审核！",
    codeList: ["paid"]
  },
  {
    code: "moneyUnnecessary",
    message: "报销金额小于发票金额",
    codeList: ["reimbursementAmountTooSmall"]
  },
  {
    code: "moneyInsufficient",
    message: "提供的发票金额不足",
    codeList: ["invoiceAmountNotEnough"]
  },
  {
    code: "fail",
    message: "此费用使用了未通过查验的发票，请留意风险！",
    codeList: [
      "recognizeFail",
      "waitChecking",
      "checkIdenticalFail",
      "checkNotFound",
      "waitCheckingTomorrow",
      "verifyException",
      "delayVerify"
    ]
  }
];
